import React from 'react';

import { LinkButton } from '@adsk/alloy-react-button';
import { AlertWarningIcon } from '@adsk/alloy-react-icon';
import { useLocale } from '@adsk/alloy-react-locale';
import { useTheme } from '@adsk/alloy-react-styles';

import useLoadMoreData from '../useLoadMoreData';

const DefaultError = ({
  onRetry,
}: Pick<ReturnType<typeof useLoadMoreData>, 'onRetry'>) => {
  const { T } = useLocale(({ locale }) => require(`../i18n/${locale}.json`));
  const theme = useTheme();
  const errorTokens = theme.tokens?.component?.loadMoreData?.error;
  return (
    <>
      <AlertWarningIcon
        size={20}
        style={{
          marginRight: errorTokens?.['margin-right'],
          color: errorTokens?.color,
        }}
      />
      <span css={errorTokens}>{T.translate('COULDNT_LOAD')}</span>
      <LinkButton
        data-testid="tryAgain"
        onClick={onRetry}
        size={LinkButton.SIZES.SMALL}
      >
        {T.translate('TRY_AGAIN')}
      </LinkButton>
    </>
  );
};

export default DefaultError;
